import { useColorModeValue } from "@chakra-ui/react"

function useColorModeBranding() {
  // Using default color scheme when in dark mode.
  return useColorModeValue("brand", undefined)
}

export default useColorModeBranding
